import { useEffect, useState } from "react";
import { X, Check } from "lucide-react";
import { getOrderTypes } from "../../services/ordertype.service";
import {
  getDriverOrderTypes,
  attachOrderType,
  detachOrderType,
} from "../../services/driverOrderType.service";
import "./AssignOrderTypeModal.css";

import { useToast } from "../../context/ToastContext";

export default function AssignOrderTypeModal({ driver, onClose }) {
  const [orderTypes, setOrderTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [initialTypes, setInitialTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const { showToast } = useToast();

  useEffect(() => {
    if (driver) loadData();
  }, [driver]);

  async function loadData() {
    try {
      setLoading(true);

      const types = await getOrderTypes();
      const assigned = await getDriverOrderTypes(driver.id);

      const assignedIds =
        assigned?.driver_order_types?.map((t) => t.id_orderType) || [];
      setOrderTypes(types || []);
      setSelectedTypes(assignedIds);
      setInitialTypes(assignedIds);
    } finally {
      setLoading(false);
    }
  }

  function toggleType(id) {
    setSelectedTypes((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id],
    );
  }

  async function handleSave() {
    const toAttach = selectedTypes.filter((id) => !initialTypes.includes(id));
    const toDetach = initialTypes.filter((id) => !selectedTypes.includes(id));
    try {
      for (const id of toAttach) {
        await attachOrderType(driver.id, id);
      }
      for (const id of toDetach) {
        await detachOrderType(driver.id, id);
      }
      showToast("Types de commandes chargés", "success");
      onClose();
    } catch (e) {
      console.error("Erreur lors de la sauvegarde:", e);
      showToast("Erreur lors de la sauvegarde", "error");
    }
  }

  const filtered = orderTypes.filter((t) =>
    t.name.toLowerCase().includes(search.toLowerCase()),
  );

  if (!driver) return null;

  return (
    <div className="assignOverlay" onClick={onClose}>
      <div className="assignModal" onClick={(e) => e.stopPropagation()}>
        <div className="assignHeader">
          <h3>Types de commandes</h3>
          <button className="closeBtn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="assignTopBar">
          <input
            type="text"
            placeholder="Rechercher..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <span className="selectedCount">
            {selectedTypes.length} sélectionné(s)
          </span>
        </div>

        {loading && <div className="assignLoading">Chargement...</div>}

        {!loading && (
          <div className="typesGrid">
            {filtered.map((type) => {
              const selected = selectedTypes.includes(type.id);

              return (
                <div
                  key={type.id}
                  className={`typeCard ${selected ? "active" : ""}`}
                  onClick={() => toggleType(type.id)}
                >
                  <div className="typeName">{type.name}</div>

                  {selected && (
                    <div className="typeCheck">
                      <Check size={16} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        <div className="assignFooter">
          <button className="cancelBtn" onClick={onClose}>
            Annuler
          </button>

          <button className="saveBtn" onClick={handleSave}>
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
